"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        // Load Twitter's widget.js in index.html.
        return (React.createElement("a", { href: "https://twitter.com/share?ref_src=twsrc%5Etfw", className: "twitter-share-button", "data-show-count": "false", "data-size": "large" }, "Tweet"));
    };
    default_1.prototype.componentWillMount = function () {
        var script = document.createElement("script");
        script.src = "https://platform.twitter.com/widgets.js";
        script.async = true;
        document.body.appendChild(script);
    };
    return default_1;
}(React.Component));
exports.default = default_1;



//////////////////
// WEBPACK FOOTER
// ./src/component/TwitterButton.tsx
// module id = 660
// module chunks = 0